<template>
  <div class="container">
    <ul class="list-group">
      <li class="list-group-item p-0" :key="key" v-for="(pokemon,key) in orderedPokemonList">
        <card-list :pokemon="pokemon"></card-list>
      </li>
    </ul>
  </div>
</template>

<script>
import Cardlist from "./Cardlist.vue";
import {useStore} from 'vuex'
import {GET_POKEMONS_BY_RANGE_OF_ID} from "@/store/pokemon/types";
import {defineComponent} from "vue";

export default defineComponent({
  name: "Pokelist",
  components: {
    "card-list": Cardlist
  },
  setup() {
    const store = useStore()
    if (store.getters.getPokemonList.length === 0) {
      store.dispatch(GET_POKEMONS_BY_RANGE_OF_ID, {
        startIndex: 1,
        endIndex: 898
      });
    }

    return {
      // access a state in computed function
      orderedPokemonList: store.getters.orderedPokemonList,
    }
  }
})
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
